export enum TipoActividad{
    senderismo = "Senderismo",
    ciclismo = "Ciclismo"
}